import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { defaultItemModalAssets, itemModalAssetsValidatorSchema } from '../../item-modal/types/assets';
/**
 * Default assets for the Item Picker component.
 */
export const defaultItemPickerAssets = Object.assign(Object.assign({}, defaultItemModalAssets), { failedToLoadDataIconName: 'generic-error-message', noItemsIconName: 'item-image-placeholder' });
export const itemPickerAssetsValidator = Validator.object(Object.assign(Object.assign({}, itemModalAssetsValidatorSchema), { failedToLoadDataIconName: nonEmptyStringValidator, noItemsIconName: nonEmptyStringValidator }));
